<template>
  <div class="practice-train">
    <!--      <div class="practice-train-header">-->
    <!--        课程筛选<el-cascader :props="cascaderProp" @change="selectCourse" style="margin-left: 10px" v-model="courseValue" :options="courseList"></el-cascader>-->
    <!--      </div>-->
    <el-scrollbar class="main-left" :native="false">
      <div class="left-box">
        <div class="left-item" @click="selectCourse(0)"><span :class="courseValue ==  0? 'span-active text-overflow' : 'text-overflow'">全部课程</span></div>
        <div class="left-item" @click="selectCourse(item.course_id)" v-for="item in courseList"><span
            :class="item.course_id === courseValue ? 'span-active text-overflow' : 'text-overflow'">{{ item.course_name }}</span>
        </div>
      </div>
    </el-scrollbar>
    <div class="main-tight">
      <el-table class="customTable" :data="trainList"
                style="width: 100%; margin-top: 16px; flex: 1;" height="1%" size="medium"
                :header-cell-style="{fontWeight: 'normal', height: '60px', color: '#666666', background: '#F6F6F6',fontSize: '16px'}"
                :cell-style="{fontSize: '16px',color: '#333333',height: '70px'}">
        <el-table-column prop="op_name" align="left" label="试题名称"></el-table-column>
        <el-table-column prop="assess_time" align="center" label="考核时间">
          <template slot-scope="scope">
            <span>{{scope.row.assess_time}}分钟</span>
          </template>
        </el-table-column>
        <el-table-column prop="drill_num" align="center" label="训练次数">
          <template slot-scope="scope">
            <span>{{scope.row.drill_num}}次</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-link class="reset-btn" @click="resetBtn(scope.row)" :underline="false">重置训练</el-link>
            <el-link type="success" :underline="false"
                     @click="toStartTraining(scope.row)">开始训练
            </el-link>
            <el-link type="success" :underline="false" @click="toAnswerDetail(scope.row)">答题详情</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pager-center" style="margin: 20px;text-align: center"
                     :current-page="listPages.currentPageNum"
                     :page-size="listPages.eachPageNum"
                     :total="listPages.total"
                     layout="prev, pager, next, jumper"
                     @current-change="listPagesCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {examTeaOperationList, getSchoolCourse, kefu_drillStuResetDrill} from '@/utils/apis'

export default {
  name: "Practice",
  data() {
    return {
      courseValue: 0,
      courseList: [],
      trainList: [],
      listPages: {
        currentPageNum: 1,
        eachPageNum: 10,
        total: 0,
      },
      cascaderProp: {value: 'id', label: 'name', children: 'child'},
      course_id: '', //课程id
      chapter_index: '', //章节id
      node_index: '', //节id
    }
  },
  mounted() {
    this.getCourseList();
    this.getTrainList();
    // this.getTrainList()
  },
  methods: {
    //获取课程
    getCourseList() {
      getSchoolCourse({}).then((res) => {
        // if(res.data.length){
        //   let list = [];
        //   res.data.forEach(item=>{
        //     let obj = {
        //       id:item.course_id,
        //       name:item.course_name,
        //       child:item.data
        //     }
        //     list.push(obj)
        //   })
        //   this.course_id = list[0].id;
        //   this.chapter_index = list[0].child[0].id;
        //   this.node_index = list[0].child[0].child[0].id;
        //   this.courseValue = [this.course_id,this.chapter_index,this.node_index]
        //   this.courseList = list;
        //   this.getTrainList()
        // } else {
        //   this.courseList = []
        // }
        this.courseList = res.data;
        // this.courseValue = this.courseList[0].course_id;
      }).catch((err) => {
        console.log('err', err)
      })
    },
    getTrainList() {
      let params = {
        paging: 1,
        page: this.listPages.currentPageNum,
        pageSize: this.listPages.eachPageNum
      }
      if (this.courseValue) {
        params.course_id = this.courseValue
      }
      examTeaOperationList(params).then((res) => {
        this.trainList = res.data.data;
        this.listPages.total = res.data.total;
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 筛选课程
    selectCourse(id) {
      this.listPages.currentPageNum = 1
      this.courseValue = id;
      this.getTrainList()
    },
    resetBtn(row) {
      const confirmText = ['1.重置训练将会清空当前训练数据，学生可以重新开始训练', '2.每一次训练成绩详情可在答题详情进行查看'];
      const newDatas = [];
      const h = this.$createElement;
      for (let i in confirmText) {
        newDatas.push(h('p', null, confirmText[i]))
      }
      this.$confirm('提示信息', {
        title: '提示信息',
        message: h('div', null, newDatas),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'green-message-box',
      }).then(() => {
        let params = {
          id:row.id,
          course_id:row.course_id,
          chapter:row.chapter_id,
          node:row.node_id
        }
        kefu_drillStuResetDrill(params).then((res)=>{
          this.$message.success(res.msg)
          this.getTrainList()
        }).catch((err)=>{
          console.log('err',err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    // 开始训练
    toStartTraining(row) {
      this.$router.push({
        path: '/student/trainCenter/startTraining/onlineShopCustomerService',
        query: {
          id: row.id,
          course_id: row.course_id,
          chapter: row.chapter_id,
          node: row.node_id,
        }
      });
    },
    // 答题详情
    toAnswerDetail(row) {
      this.$router.push({
        path: '/student/trainCenter/answerDetail',
        query: {
          id: row.id,
          course_id:row.course_id,
          chapter_id:row.chapter_id,
          lesson_id:row.node_id
        }
      })
    },
    listPagesCurrentChange(val) {
      this.listPages.currentPageNum = val;
      this.getTrainList();
    }
  }
}
</script>

<style scoped lang="scss">
.practice-train {
  padding: 0px 20px;
  box-sizing: border-box;
  height: 100%;
  display: flex;

  .main-left {
    z-index: 98;
    //background: #F6F7FC;
    position: relative;
    top: -20px;
    height: calc(100% + 20px);
    border-right: 20px solid #F6F7FC;

    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .left-box {
      width: 210px;
      display: flex;
      flex-direction: column;

      .left-item {
        width: 100%;
        cursor: pointer;
        line-height: 1;
        margin: 16px 0;
        display: flex;

        span {
          line-height: 1;
          color: #666;
          font-size: 14px;
        }

        .span-active {
          color: #F23B2F;
        }
      }
    }
  }

  .main-tight {
    flex: 1;
    width: 1%;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }
}

.reset-btn {
  &:hover {
    color: #606266;
  }
}
</style>